import { useLocation } from "react-router-dom";
import { SHOPIFY_BILLING_ENABLED } from "../../constants/featureFlags";
import { isKioskMode } from "../../helpers/posModeHelpers";
import { useFeatureFlag } from "../../hooks/globalSettingsHooks";
import { useGetStoreInfo } from "../../hooks/settingHooks";
import { SubscriptionStatus } from "../../types/subscriptions";
import ShopifySubscriptionAlert from "../shopifySubscription/ShopifySubscriptionAlert";

interface ShopifySubscriptionCheckProps {
  children: React.ReactNode;
}

function ShopifySubscriptionCheck({ children }: ShopifySubscriptionCheckProps) {
  const isShopifyBillingFlagEnabled = useFeatureFlag(SHOPIFY_BILLING_ENABLED);
  const { data: storeInfo } = useGetStoreInfo();
  const { pathname } = useLocation();
  const subscriptionIsPending =
    storeInfo?.shopify?.subscription?.status === SubscriptionStatus.Pending;
  const isOnSubscriptionPage = pathname === "/shopifySubscription";

  if (
    isOnSubscriptionPage ||
    isKioskMode() ||
    !isShopifyBillingFlagEnabled ||
    !subscriptionIsPending
  ) {
    return <>{children}</>;
  }

  const confirmationUrl = storeInfo?.shopify?.subscription?.confirmationUrl;

  return (
    <>
      <ShopifySubscriptionAlert
        confirmationUrl={confirmationUrl}
        forceShow={false}
      />
      {children}
    </>
  );
}

export default ShopifySubscriptionCheck;
